import { createContext } from "react";

export const PaymentStepContext = createContext({
  clientSecret: null,
  paymentIntentId: null,
  isStripeReady: false,
  onStripeChange: () => {},
});
